{
  "access": {
    "board": {
      "title": "My access",
      "mapTitle": "What I can reach",
      "leads": "Your lead:",
      "why": "Why?",
      "hideWhy": "Hide",
      "whyLoading": "Loading…",
      "whyError": "Could not load why.",
      "requestsTitle": "My requests",
      "requestedRole": "Requested: {{role}}",
      "cancel": "Withdraw",
      "cancelling": "Withdrawing…",
      "empty": {
        "title": "No access yet",
        "description": "Resources you can reach appear here as they are shared with you or your team."
      },
      "noRequests": {
        "title": "No open requests",
        "description": "Access you request shows here with its status."
      },
      "loadError": "Could not load your access overview.",
      "resourceTypeError": "Could not load {{type}} — some access may not be shown.",
      "chatPlaceholder": "Ask about your access…"
    },
    "openAssistant": "Open the My Access assistant",
    "team": {
      "title": "Team access",
      "summary": "{{members}} members · {{requests}} open requests",
      "openAssistant": "Open the Team Access assistant",
      "inbox": {
        "title": "Approvals",
        "approve": "Approve",
        "deny": "Deny",
        "deciding": "Working…",
        "confirmDeny": "Send denial",
        "cancel": "Cancel",
        "denyReasonLabel": "Reason (optional)",
        "denyReasonPlaceholder": "Why is this request declined?",
        "empty": {
          "title": "Inbox clear",
          "description": "Access requests for your team appear here to approve or deny."
        }
      },
      "composer": {
        "title": "Grant access",
        "who": "Who",
        "whoPlaceholder": "Choose a person or role group",
        "what": "Resource",
        "whatPlaceholder": "Choose a resource",
        "role": "Role",
        "membersGroup": "People",
        "rolesGroup": "Role groups",
        "expiry": "Expires",
        "expiryChoice": {
          "end_of_shift": "End of shift",
          "permanent": "No expiry",
          "until": "Until…"
        },
        "untilLabel": "Expires at",
        "grant": "Grant",
        "granting": "Granting…",
        "relativeHours": "+{{hours}} h"
      },
      "roster": {
        "title": "Team roster",
        "otherGroup": "Others",
        "expiringSoon": "Expiring soon",
        "grants_one": "Access",
        "grants_other": "Access",
        "moreGrants": "+{{count}} more",
        "openRequests_one": "{{count}} open request",
        "openRequests_other": "{{count}} open requests",
        "revoke": "Revoke access",
        "empty": {
          "title": "No team members",
          "description": "People on your team appear here with their access."
        }
      },
      "loadError": "Could not load the team access board.",
      "chatPlaceholder": "Ask the agent to propose a grant…",
      "switchUnit": "Switch unit",
      "leadOnly": {
        "title": "Unit leads only",
        "description": "Only this unit's lead can see the team's access board."
      },
      "notFramed": "This conversation isn’t framed to a unit yet."
    },
    "proposal": {
      "action": {
        "grant": "Grant access",
        "revoke": "Revoke access",
        "approve": "Approve request"
      },
      "confirm": {
        "grant": "Grant",
        "revoke": "Revoke",
        "approve": "Approve"
      },
      "confirming": "Working…",
      "dismiss": "Dismiss"
    },
    "request": {
      "title": "No access",
      "lockedType": "{{type}} — not shared with you",
      "canSee": "You can still open",
      "sent": "Request sent",
      "alreadyAuthorized": "You already have access",
      "alreadyPending": "Request already pending",
      "justificationPlaceholder": "Why do you need access? (optional)",
      "request": "Request access",
      "sending": "Sending…",
      "addJustification": "Add a reason",
      "thisResource": "This conversation"
    },
    "explanation": {
      "title": "How you reach this"
    },
    "source": {
      "direct": "direct",
      "group_membership": "via role",
      "org_cascade": "via unit",
      "patient_care_team": "via care team",
      "team_supervision": "via supervision",
      "public": "organisation-wide",
      "admin": "admin override",
      "inherited": "inherited"
    },
    "role": {
      "viewer": "Viewer",
      "editor": "Editor",
      "owner": "Owner",
      "nurse": "Nurse",
      "shift_coordinator": "Shift coordinator",
      "therapist": "Therapist"
    },
    "relation": {
      "member": "member of",
      "staffs": "staffs",
      "cares_for": "cares for",
      "covers": "covers",
      "shared_with": "shared directly",
      "org_wide": "shared organisation-wide",
      "entitled": "entitled to",
      "platform_admin": "platform admin",
      "unit_lead": "unit lead"
    },
    "resourceType": {
      "patient_one": "Patient",
      "patient_other": "Patients",
      "session_one": "Session",
      "session_other": "Sessions",
      "document_one": "Document",
      "document_other": "Documents",
      "feature_one": "Feature",
      "feature_other": "Features",
      "unit_one": "Unit",
      "unit_other": "Units"
    },
    "locationKind": {
      "hospital": "Hospital",
      "building": "Building",
      "ward": "Ward",
      "icu": "ICU",
      "bed": "Bed"
    },
    "expiry": {
      "min_one": "in {{count}} min",
      "min_other": "in {{count}} min",
      "hour_one": "in {{count}} h",
      "hour_other": "in {{count}} h",
      "day_one": "in {{count}} day",
      "day_other": "in {{count}} days",
      "expired": "expired"
    },
    "status": {
      "pending": "Pending",
      "approved": "Approved",
      "denied": "Denied",
      "expired": "Expired",
      "cancelled": "Withdrawn"
    },
    "patient": {
      "requestDemographics": "Request details"
    },
    "unitScope": {
      "choose": {
        "title": "Choose a unit",
        "description": "You can manage several units. Pick the one to work on.",
        "error": "Could not set the unit. Pick again to retry."
      },
      "noAuthority": {
        "title": "No unit yet",
        "description": "This board is for unit leads. Set your workplace in your profile, or ask an admin to make you the lead of a unit.",
        "descriptionWithUnit": "This board is for unit leads. You work in {{unit}}, but aren't its lead yet — ask an admin to make you the lead, or set a different workplace.",
        "setWorkplace": "Set your workplace"
      }
    }
  },
  "org": {
    "accessRequests": {
      "title": "Access requests",
      "requestAccess": "Request access",
      "sent": "Request sent to the unit's owner.",
      "alreadyPending": "You already have a pending request for this unit.",
      "approve": "Approve",
      "deny": "Deny",
      "alreadyAuthorized": "You already have access."
    },
    "labels": {
      "title": "Labels (optional)",
      "keyPlaceholder": "key",
      "valuePlaceholder": "value",
      "remove": "Remove label",
      "addLabel": "Add label"
    },
    "accessLevel": {
      "viewer": "viewer",
      "editor": "editor",
      "owner": "owner"
    },
    "location": {
      "editTitle": "Edit unit",
      "newTitle": "New unit",
      "editDesc": "Rename this unit or adjust its labels. Its kind and place in the tree do not change here.",
      "newChildDesc": "A new unit inside {{parent}}.",
      "newRootDesc": "A new top-level unit (e.g. a hospital).",
      "kindLabel": "Kind",
      "namePlaceholder": "e.g. ICU 2",
      "noKinds": "No kinds configured"
    },
    "move": {
      "title": "Move {{name}}",
      "desc": "Choose a new parent unit. Access cascades from the parent down, so moving a unit moves its whole subtree with it.",
      "topLevel": "— Top level (no parent) —",
      "button": "Move"
    },
    "assign": {
      "title": "Assign to {{name}}",
      "desc": "Give a person or a whole role access to this unit. Viewer works here · editor manages it · owner runs it. Access cascades to every sub-unit.",
      "person": "Person",
      "role": "Role",
      "selectRole": "Select a role…",
      "accessLevel": "Access level",
      "button": "Assign"
    },
    "admit": {
      "title": "Admit a patient to {{name}}",
      "desc": "Select a patient to place in this unit. If they are already in another unit, this transfers them here."
    },
    "role": {
      "editTitle": "Edit role",
      "newTitle": "New role",
      "desc": "A role is a named group of people. Assign it to units and resources, and its members inherit the access.",
      "namePlaceholder": "e.g. ICU Nurses",
      "descLabel": "Description (optional)",
      "descPlaceholder": "What this role is for",
      "selfSelectable": "Self-selectable during onboarding"
    },
    "roleMember": {
      "title": "Add member to {{name}}",
      "desc": "Everyone in this role inherits its access to units and resources."
    },
    "grant": {
      "title": "Grant access · {{name}}",
      "desc": "Let everyone in this role reach a specific resource at the chosen level.",
      "resourceTypeLabel": "Resource type",
      "noResourceTypes": "No resource types configured",
      "resourceIdLabel": "Resource ID",
      "resourceIdPlaceholder": "the resource's id",
      "button": "Grant"
    },
    "console": {
      "locations": "Locations",
      "roles": "Roles"
    },
    "locationsView": {
      "units": "Units",
      "new": "+ New",
      "emptyTitle": "No units yet",
      "emptyHint": "Create your hospital to start the tree, then add buildings, wards, and beds inside it.",
      "createFirst": "Create the first unit",
      "buildOrg": "Build your organisation",
      "selectUnit": "Select a unit",
      "createFirstHint": "Create the first unit on the left.",
      "selectUnitHint": "Pick a unit on the left to manage who works there and which patients it holds."
    },
    "rolesView": {
      "roles": "Roles",
      "new": "+ New",
      "emptyTitle": "No roles yet",
      "emptyHint": "A role groups people by function — ICU Nurses, Ward Doctors — so you assign access once, to the role.",
      "createRole": "Create a role",
      "defineRoles": "Define your roles",
      "selectRole": "Select a role",
      "createFirstHint": "Create the first role on the left.",
      "selectRoleHint": "Pick a role to manage its members and what it can reach."
    },
    "ui": {
      "patientCount": "{{count}} patient",
      "patientCount_other": "{{count}} patients",
      "remove": "Remove"
    },
    "tree": {
      "collapse": "Collapse",
      "hiddenParentTitle": "Parent unit is outside your access",
      "hiddenParent": "↑ hidden parent",
      "censusContext": "in {{name}} and its sub-units",
      "addChild": "Add a unit inside {{name}}"
    },
    "permissions": {
      "adminTier": "Admin access (platform)",
      "targets": "Targets",
      "targetsHint": "Platform authority, every admin area, and every agent you can grant.",
      "noTargets": "No grantable targets",
      "noTargetsHint": "The platform exposes no admin areas to grant. This usually means the authz model has not been configured.",
      "selectTarget": "Select a target",
      "selectTargetHint": "Pick a platform authority, an admin area or an agent on the left to see who can reach it and grant access.",
      "grantAccess": "Grant access",
      "whoCanReach": "Who can reach this",
      "noGrants": "No one has been granted this",
      "noGrantsHint": "Grant a person or a role one of this target's relations.",
      "revokeAdminConfirm": "Remove full platform-admin access for \"{{label}}\"?\n\nRevoking the last admin will lock the organisation out of admin UI. Only proceed if another admin remains.",
      "revoke": "Revoke",
      "groupPlatform": "Platform",
      "groupAreas": "Admin areas",
      "groupAgents": "Agents",
      "agentRestricted": "Restricted — opens only for who is granted it here",
      "agentOpen": "Open to everyone — a grant adds nothing",
      "areaSensitive": "Cross-user, user-identifying content"
    },
    "roleDetail": {
      "members": "Members",
      "add": "+ Add",
      "noMembers": "No members",
      "noMembersHint": "Add people to this role; they inherit everything the role can reach.",
      "addMember": "Add a member",
      "accessToResources": "Access to resources",
      "grant": "+ Grant",
      "noGrants": "No resource access",
      "noGrantsHint": "Grant this role access to a specific resource (a document, a session, a unit…) at viewer, editor, or owner level.",
      "grantAccess": "Grant access",
      "truncated": "Showing the first page of grants — more exist.",
      "deleteTitle": "Delete {{name}}?",
      "deleteDesc": "This removes the role and the access its members inherited through it. People keep any access granted to them directly."
    },
    "locationDetail": {
      "tier": {
        "owner": "Owners — run this unit",
        "editor": "Editors — manage this unit",
        "viewer": "Viewers — work in this unit"
      },
      "whoHasAccess": "Who has access",
      "assign": "+ Assign",
      "noAccess": "No one assigned yet",
      "noAccessHint": "Assign a person or a role. Viewer works here, editor manages it, owner runs it — and access cascades to every sub-unit.",
      "assignSomeone": "Assign someone",
      "byRole": "By role",
      "inherited": "Inherited from parent units",
      "fromSource": "from {{source}}",
      "subtreeStaffing": "Staffing across sub-units",
      "roleTag": "role",
      "roleMembersError": "Could not load who is in this role",
      "roleMembersLoading": "Loading members…",
      "roleMembersEmpty": "No one in this role yet",
      "morePreview": "+{{count}} more",
      "roleMemberCount": "{{count}} person: {{list}}",
      "roleMemberCount_other": "{{count}} people: {{list}}",
      "patientsInUnit": "Patients in this unit",
      "directlyInUnit": "Directly in this unit",
      "rolledUpHint": "Rolled up across every sub-unit. Select a sub-unit on the left to admit, discharge, or move its patients.",
      "discharge": "Discharge",
      "admit": "+ Admit",
      "noPatients": "No patients here",
      "noPatientsHint": "Admit a patient to place them in this unit; staff assigned here will see them automatically.",
      "admitPatient": "Admit a patient",
      "labels": "Labels",
      "deleteTitle": "Delete {{name}}?",
      "deleteDesc": "This removes the unit and the access that flows through it. A unit with sub-units or admitted patients can't be deleted — move or discharge them first.",
      "schema": {
        "title": "Patient fields recorded here",
        "yourView": "Resolved for your own profession — another profession records a different set.",
        "empty": "No patient fields at this unit",
        "emptyHint": "The platform base declares none for your profession, and no layer on this unit adds one.",
        "readOnly": "Readable, not writable",
        "layers": "Layers on this unit’s chain",
        "minted": "server-minted"
      }
    },
    "patientContext": {
      "title": "Patient context",
      "subtitle": "What the platform records about a patient in this unit, and what agents working here can read.",
      "edit": "Edit unit fields",
      "empty": "No fields are recorded for patients here.",
      "sourcePlatform": "platform",
      "sourceOwn": "this unit",
      "required": "required",
      "coded": "{{count}} coded",
      "editTitle": "Patient fields for {{unit}}",
      "editDescription": "These are the fields this unit adds. Inherited fields are edited where they were declared.",
      "noOwnFields": "This unit adds no fields of its own yet.",
      "keyPlaceholder": "field name, e.g. severity",
      "values": "Allowed values (comma separated; empty means free text)",
      "classes": "Context classes (comma separated)",
      "codings": "Optional terminology coding per value. Only a listed value can be coded.",
      "addField": "Add a field",
      "inheritedNote": "Inherited here: {{keys}}",
      "reset": "Inherit from parent"
    }
  },
  "app": {
    "name": "AI for Nurses",
    "tagline": "Knowledge for intensive care"
  },
  "common": {
    "cancel": "Cancel",
    "save": "Save",
    "saving": "Saving...",
    "delete": "Delete",
    "edit": "Edit",
    "loading": "Loading...",
    "updating": "Updating…",
    "staleData": "Showing cached data — refresh failed",
    "error": "An error occurred",
    "back": "Back",
    "backHome": "Back to Home",
    "returnToMainAgent": "{{brand}}",
    "optional": "optional",
    "expand": "Expand",
    "yes": "Yes",
    "no": "No",
    "serverStarting": "Warming up the server...",
    "submitting": "Submitting…",
    "dismiss": "Dismiss",
    "goBack": "Go back",
    "create": "Create",
    "add": "Add",
    "name": "Name",
    "required": "required"
  },
  "auth": {
    "login": "Log In",
    "register": "Register",
    "createAccount": "Create Account",
    "logout": "Log Out",
    "email": "Email",
    "password": "Password",
    "confirmPassword": "Confirm Password",
    "noAccount": "No account yet?",
    "hasAccount": "Already have an account?",
    "loginFailed": "Login failed. Please check your credentials.",
    "registerFailed": "Registration failed. Please try again.",
    "registerClosed": "Tricorder is in closed preview — accounts are by invitation. Ask your team lead to invite you.",
    "emailExists": "This email is already registered.",
    "passwordMismatch": "Passwords do not match",
    "passwordPlaceholder": "At least 8 characters",
    "passwordRepeatPlaceholder": "Repeat password",
    "error": {
      "sessionExpired": "Session expired",
      "sessionExpiredDesc": "Your login session expired or was invalid. Please try again."
    },
    "notice": {
      "alreadyVerified": "Already verified",
      "alreadyVerifiedDesc": "Your email is already confirmed. Please log in."
    },
    "orEmail": "or continue with email",
    "notVerified": {
      "title": "Please verify your email",
      "description": "This account hasn't been verified yet. Open the link in the email we sent you.",
      "resend": "Resend verification"
    },
    "verify": {
      "inbox": {
        "title": "Check your inbox",
        "description": "We sent a verification link to the address below. Open it to finish creating your account.",
        "noEmail": "Didn't get the email?",
        "resend": "Resend email",
        "resent": "Sent. Check your inbox again."
      },
      "pending": {
        "title": "Verifying your email…",
        "description": "One moment while we activate your account."
      },
      "invalid": {
        "title": "Link invalid or expired",
        "description": "This verification link is no longer valid. Enter your email address to get a new one.",
        "resend": "Send a new link",
        "resent": "If an account exists, a new link is on its way.",
        "backToLogin": "Back to login"
      },
      "unavailable": {
        "title": "Verification temporarily unavailable",
        "description": "We couldn't check the link just now. Please try again.",
        "retry": "Try again"
      },
      "resendFailed": "Couldn't send the email. Please try again in a moment."
    },
    "continueWithGoogle": "Continue with Google",
    "emailPlaceholder": "name@hospital.ch",
    "passwordDotsPlaceholder": "••••••••",
    "registerClosedTitle": "Accounts are by invitation",
    "setPassword": {
      "title": "Set your password",
      "description": "You arrived through your invitation — choose a password to activate your account.",
      "submit": "Activate account",
      "backToLogin": "Back to login",
      "invalid": {
        "title": "This link is not complete",
        "description": "Use the set-password link from your invitation email. No link? Ask your team lead."
      },
      "expired": "This link is no longer valid.",
      "expiredHint": "A newer link may have been sent — use the most recent email, or ask your team lead.",
      "alreadySet": "The password is already set. Sign in with it, or use \"forgot password\" from your team lead."
    }
  },
  "oauthConsent": {
    "heading": "Connect “{{clientName}}”?",
    "unnamedClient": "Unnamed app",
    "lead": "It’s asking for access to your Tricorder account, as {{email}}.",
    "labelAccess": "Access",
    "labelResource": "Resource",
    "approve": "Allow",
    "deny": "Don’t allow",
    "errorTitle": "Connection failed",
    "invalidRequest": "This connection link is invalid or incomplete. Start the connection again from the app.",
    "unknownClient": "This app isn’t registered with Tricorder. Start the connection again from the app.",
    "submitError": "The request could not be completed. Please try again.",
    "scopes": {
      "mcp": "Use Tricorder tools on your behalf"
    }
  },
  "home": {
    "title": "Conversations",
    "admin": "Admin",
    "assistantPrefix": "Digital Assistant",
    "showSidebar": "Show sidebar",
    "hideSidebar": "Hide sidebar",
    "searchAgents": "Search agents…",
    "noAgentMatch": "No agent matches.",
    "search": "Search sessions...",
    "new": "Ask a new question",
    "loadError": {
      "title": "Couldn't load sessions",
      "retry": "Retry"
    },
    "myPatients": {
      "empty": {
        "title": "No patients assigned",
        "description": "Start a shift to see your patients here."
      },
      "noSessions": "No conversations for this patient yet",
      "loadError": {
        "title": "Couldn't load your patients"
      }
    },
    "personal": {
      "empty": {
        "title": "No personal conversations",
        "description": "Conversations not tied to a patient appear here."
      }
    },
    "team": {
      "empty": {
        "title": "No team conversations",
        "description": "Ward-level team work appears here."
      }
    },
    "previousPatients": {
      "row": "Previous patients ({{count}})",
      "title": "Previous patients",
      "empty": {
        "title": "No previous patients",
        "description": "Patients you've worked with appear here."
      },
      "noSessions": "No conversations for this patient"
    },
    "scope": {
      "patients": "Patients",
      "personal": "Personal",
      "team": "Team"
    },
    "shift": "My shift",
    "section": {
      "conversations": "Conversations"
    },
    "headerAction": {
      "notices": "Notices",
      "knowledge": "Knowledge"
    },
    "openAgent": "Open agent",
    "newConversation": "New conversation",
    "launcherFor": "Open an agent for {{label}}",
    "noAnswerYet": "No answer yet",
    "viewSource": "View source",
    "selectConversation": {
      "title": "Select a conversation",
      "description": "Choose a conversation to see its answer and source."
    },
    "launcherPersonal": "Open a personal agent",
    "launcherTeam": "Open a team agent",
    "handover": {
      "receivedFrom": "Handover from {{name}}",
      "receivedUnknown": "Handover",
      "viewRapport": "View handover Rapport"
    }
  },
  "actions": {
    "retry": "Retry",
    "retrying": "Retrying…",
    "report": "Report",
    "reported": "Reported",
    "close": "Close",
    "submit": "Submit",
    "confirm": "Confirm",
    "cancel": "Cancel"
  },
  "agentic": {
    "pleaseSelect": "Please select...",
    "continue": "Continue",
    "noLongerActive": "No longer active — continue below",
    "validation": {
      "required": "This field is required",
      "invalidNumber": "Please enter a valid number",
      "minValue": "Value must be at least {{min}} {{unit}}",
      "maxValue": "Value must be at most {{max}} {{unit}}"
    },
    "submit": "Submit",
    "protocol": {
      "endOfProtocol": "[End of protocol]",
      "nameUnavailable": "Protocol name unavailable",
      "badge": {
        "step": "Step",
        "decision": "Decision",
        "observation": "Observation",
        "action": "Action",
        "terminal": "Terminal"
      }
    }
  },
  "bookmarks": {
    "notFound": "Bookmark not found",
    "createError": "Could not create bookmark."
  },
  "onboarding": {
    "validation": {
      "assistantNameRequired": "Name is required"
    },
    "years": {
      "new": "New",
      "1-2": "1-2 years",
      "2-5": "2-5 years",
      "3-5": "3-5 years",
      "5-10": "5-10 years",
      "6-10": "6-10 years",
      "10-20": "10-20 years",
      "20+": "20+ years"
    },
    "specialisations": {
      "icu": "Intensive Care (ICU)",
      "anesthesia": "Anesthesia",
      "emergency": "Emergency Department (ED)",
      "internal_medicine": "Internal Medicine",
      "surgery_visceral": "Visceral Surgery",
      "surgery_vascular": "Vascular and Transplant Surgery",
      "cardiology": "Cardiology",
      "neurology": "Neurology",
      "neurosurgery": "Neurosurgery",
      "oncology": "Oncology",
      "pneumology": "Pneumology",
      "gastroenterology": "Gastroenterology and Hepatology",
      "nephrology": "Transplant Immunology and Nephrology",
      "hematology": "Hematology",
      "infectiology": "Infectiology and Hospital Hygiene",
      "endocrinology": "Endocrinology, Diabetology and Metabolism",
      "rheumatology": "Rheumatology",
      "dermatology": "Dermatology",
      "ophthalmology": "Ophthalmology",
      "ent": "Ear, Nose and Throat (ENT)",
      "urology": "Urology",
      "gynecology": "Gynecology and Obstetrics",
      "orthopaedics": "Orthopaedics and Traumatology",
      "plastic_surgery": "Plastic, Reconstructive and Hand Surgery",
      "thoracic_surgery": "Thoracic Surgery",
      "spinal_surgery": "Spinal Surgery",
      "oral_maxillofacial": "Oral and Maxillofacial Surgery",
      "radiology": "Radiology and Nuclear Medicine",
      "radiation_oncology": "Radiation Oncology",
      "psychosomatics": "Psychosomatics",
      "clinical_pharmacology": "Clinical Pharmacology and Toxicology",
      "palliative_care": "Palliative Care",
      "rehabilitation": "Therapies / Rehabilitation",
      "medical_polyclinic": "Medical Polyclinic",
      "surgical_polyclinic": "Surgical Polyclinic",
      "other": "Other",
      "midwifery": "Midwifery and perinatology"
    },
    "institutions": {
      "usb": "Starfleet Medical"
    },
    "languages": {
      "de": "German",
      "fr": "French",
      "en": "English"
    },
    "inputPlaceholder": "Enter answer..."
  },
  "profile": {
    "title": "Profile",
    "name": "Name",
    "role": "Role",
    "specialisation": "Specialization",
    "institution": "Institution",
    "institutionEmpty": "No institution recorded",
    "unit": "Ward/Unit",
    "unitEmpty": "No ward assigned",
    "wardMemberships": "Also assigned by your organization",
    "twinName": "Assistant Name",
    "language": "Language",
    "save": "Save Changes",
    "logout": "Log Out",
    "logoutConfirm": "Do you really want to log out?",
    "validation": {
      "nameRequired": "Name is required"
    },
    "feedback": {
      "failedDescription": "Please try again later."
    },
    "summary": {
      "title": "Knowledge Profile",
      "empty": {
        "title": "No conversations yet",
        "description": "Start conversations with your digital colleague. Your knowledge profile will be created automatically."
      },
      "topics": "Focus Areas",
      "evidence": "Evidence",
      "generatedAt": "Generated",
      "regenerate": "Update",
      "regenerating": "Generating...",
      "messageCount": "message",
      "messageCount_other": "messages"
    },
    "yearsExperience": "Experience",
    "yearsExperienceValue": "{{count}} years",
    "errors": {
      "summaryGenerationFailed": "Profile could not be generated",
      "saveFailed": "Profile could not be saved",
      "orgOptionsLoadFailed": "Could not load organization options",
      "orgOptionsEmpty": "Nothing configured yet"
    },
    "narrative": "My practice",
    "narrativeEmpty": "You have not written anything about your practice yet. Tap Edit to add it.",
    "narrativePlaceholder": "What do you work with, and what matters to you in it?"
  },
  "chat": {
    "unsupportedBlock": "Unsupported content — update the app to view it.",
    "retiredAgentNotice": "This assistant is no longer available. The conversation and its history stay — replies now come from the general assistant.",
    "placeholder": "Enter question...",
    "attach": "Add attachment",
    "send": "Send message",
    "moreDetails": "More details",
    "lessDetails": "Less",
    "showSources": "Show sources",
    "hideSources": "Hide sources",
    "inboundSummary": {
      "viewFullSession": "View full session",
      "receiving": "Receiving session summary…",
      "loadError": "Could not load the summary.",
      "retry": "Retry"
    },
    "streaming": {
      "searching": "Searching",
      "citationsFound": "{{count}} source(s) found"
    },
    "errors": {
      "llmError": "AI response failed. Please try again.",
      "protocolBootstrapFailed": "The protocol could not be started. Please try again.",
      "toolCallError": "A service is temporarily unavailable. The response is based on general knowledge.",
      "streamingIncomplete": "Response incomplete. Retry?",
      "networkError": "Network error. Please check your connection.",
      "retryButton": "Retry",
      "retrying": "Retrying...",
      "imageAnalysisFailed": "I was unable to analyze the image. Try typing the medication name instead.",
      "responseGenerationFailed": "I was unable to generate a response. Please try rephrasing your question.",
      "safetyFilterBlocked": "This query was blocked by content safety policies. Please rephrase your question.",
      "unreadableFailure": "This failure record cannot be read: it does not have the shape the platform defines. Start a new conversation, and if it happens again, report it to your platform administrator."
    },
    "medication": {
      "defaultQuestion": "What medication is this?",
      "placeholder": "Question about medication...",
      "capture": "Take photo of medication",
      "imageAlt": "Medication image"
    },
    "attachment": {
      "takePhoto": "Take photo",
      "uploadDocument": "Upload document",
      "uploadDocumentDescription": "Open PDF in Document Chat",
      "invalidImageFormat": "Invalid image format. Allowed: JPEG, PNG, WebP",
      "invalidPdfFormat": "Please select a PDF file.",
      "selectImage": "Select image",
      "selectDocument": "Select document",
      "addAttachment": "Add attachment",
      "addAttachmentDescription": "Choose how to attach content to your message",
      "removeImage": "Remove image",
      "removeDocument": "Remove document",
      "processingFailed": "Image processing failed"
    },
    "scrollToBottom": "Scroll to latest",
    "scrollToLatest": "Latest",
    "turnFailed": "Couldn't finish that response. Please send your message again.",
    "turnFailedQuota": "The platform used up its AI requests for this minute: the model provider's per-minute quota is shared by everyone on the platform. Wait a minute, then send your message again. If this keeps happening, ask an administrator to request a higher quota.",
    "degradedServices": "Limited results — some reference services temporarily unavailable",
    "uiResourceDropped": "A resource card was omitted because the server returned an oversized payload.",
    "confirmation": {
      "title": "Confirmation required"
    },
    "delegation": {
      "askedBy": "Asked by {{agent}}",
      "answeredBy": "Answered by {{agent}}",
      "openConsult": "Open the consult",
      "couldNotAnswer": "{{agent}} could not answer",
      "seeConsult": "Open the consult to see where it stopped."
    },
    "handoff": {
      "genericAgent": "Specialist"
    },
    "conversation": "Conversation"
  },
  "session": {
    "returnToParent": {
      "label": "Return to session"
    },
    "shared": "Shared",
    "byAuthor": "by {{name}}",
    "newConversation": "New Conversation",
    "patientFrame": {
      "clear": "Remove patient",
      "personal": "Personal conversation",
      "shiftsError": "Could not load shift patients."
    },
    "empty": "Ask your first question to start the conversation.",
    "loadError": "Could not load session.",
    "createError": "Could not create session.",
    "gate": {
      "agentAccessRequired": "You don't have access to this assistant. Ask an admin to grant it to you or to your role.",
      "patientAccessLapsed": "You no longer have access to this patient, so no conversation can be opened for them. If they are still in your care, ask your unit lead to assign them to you again."
    },
    "renameError": "Rename failed.",
    "deleteError": "Delete failed.",
    "deleteForbidden": "You don't have permission to delete this session.",
    "deleteConnection": "Couldn't reach the server. Please try again.",
    "archiveError": "Archive failed.",
    "rename": "Rename",
    "renameTitle": "Rename Session",
    "renamePlaceholder": "New name...",
    "delete": {
      "title": "Delete session?",
      "confirm": "This session and all messages will be permanently deleted."
    },
    "topics": "Topics",
    "hideTopics": "Hide topics",
    "sharing": {
      "sharedWithYou": "{{name}} shared a session with you",
      "shareError": "Could not share session. Please try again."
    },
    "archive": "Archive",
    "archiveConfirm": "The conversation will be hidden but kept for your profile.",
    "archiveTitle": "Archive conversation?",
    "share": "Share conversation",
    "notFound": "Conversation not found"
  },
  "promptInspector": {
    "trigger": "What is the assistant told?",
    "title": "Assistant instructions",
    "explainer": "These are the standing instructions the assistant follows in this conversation.",
    "dynamic": "Live — rebuilt with the current context on every message",
    "hash": "id {{hash}}",
    "loadError": "Couldn't load the instructions.",
    "copy": "Copy",
    "copied": "Copied",
    "confidential": "May be confidential",
    "sensitiveNote": "May contain patient context — treat as confidential.",
    "layers": {
      "base": "Platform & safety rules",
      "role": "Your role & scope",
      "session": "Session context",
      "deployment": "Hospital rules",
      "patientContext": "Patient context",
      "patientSessions": "The patient's conversations"
    }
  },
  "source": {
    "pageRange": "Pages {{start}}-{{end}}",
    "viewOriginal": "View original document",
    "viewSource": "View source"
  },
  "bookmark": {
    "enriching": "Enriching",
    "enrichmentFailed": "Enrichment failed",
    "enrichmentRetrying": "Retrying...",
    "enrichmentRetryingDetail": "Retrying literature search",
    "enrichingDetail": "Enriching bookmark...",
    "enrichingSubtitle": "Searching PubMed and medical databases",
    "enrichmentRetryHint": "Click retry to try again",
    "studyTitle": "Study Bookmark",
    "viewChat": "View chat",
    "savedContent": "Saved Content",
    "originalSources": "Original Sources",
    "aiStudySummary": "AI Study Summary",
    "pubmedLiterature": "PubMed Literature",
    "medicationInfo": "Medication Information",
    "noReferences": "No additional references found for this topic.",
    "pages": "Pages",
    "relevance": "Relevance"
  },
  "search": {
    "placeholder": "Search sessions...",
    "noResults": "No results found"
  },
  "documents": {
    "loadError": "Could not load document.",
    "upload": {
      "title": "Upload Document",
      "backToList": "Back to documents",
      "fileLabel": "File",
      "acceptedTypes": "Accepted types",
      "selected": "Selected: {{name}} ({{size}} KB)",
      "titleLabel": "Title",
      "titlePlaceholder": "e.g., Sepsis Treatment Protocol 2024",
      "categoryLabel": "Category",
      "scopeLabel": "Scope",
      "scopePrivate": "Private (only me)",
      "scopeDepartment": "Department",
      "scopePublic": "Whole organisation",
      "departmentLabel": "Department",
      "departmentPlaceholder": "Select a department",
      "departmentNote": "Shared documents require admin approval before being searchable",
      "departmentLoading": "Loading departments…",
      "departmentEmpty": "No departments available",
      "departmentLoadError": "Couldn't load departments. Tap to retry.",
      "uploadButton": "Upload Document",
      "uploading": "Uploading...",
      "success": {
        "title": "Upload Complete",
        "statusLabel": "Status:",
        "chunksProcessed": "Processed {{count}} chunks",
        "pendingApprovalNotice": "Your document is pending admin approval. It will be available for search after approval.",
        "uploadAnother": "Upload Another",
        "viewDocuments": "View Documents"
      },
      "error": {
        "selectFile": "Please select a file and enter a title",
        "departmentRequired": "Please select a department",
        "unsupportedType": "Unsupported file type. Please upload {{types}}",
        "invalidTitle": "Title contains invalid characters. Please remove: < > \"",
        "uploadFailed": "Upload failed",
        "urlRequired": "Please enter a URL",
        "httpsOnly": "Only HTTPS URLs are supported",
        "invalidUrl": "Please enter a valid URL (e.g. https://pmc.ncbi.nlm.nih.gov/articles/PMC...)"
      },
      "modeFile": "File",
      "modeURL": "URL",
      "urlHint": "PubMed, PMC, or any web page",
      "urlLabel": "URL",
      "urlPlaceholder": "https://pmc.ncbi.nlm.nih.gov/articles/PMC...",
      "categoryFallback": "Guideline"
    },
    "list": {
      "title": "Knowledge Base",
      "upload": "Upload",
      "empty": {
        "title": "No documents yet"
      },
      "backHome": "Back to home",
      "table": {
        "title": "Title",
        "category": "Category",
        "status": "Status",
        "uploaded": "Uploaded",
        "chunks": "Chunks",
        "actions": "Actions",
        "visibility": "Visibility"
      },
      "delete": {
        "button": "Delete",
        "confirm": "Delete permanently?",
        "confirmButton": "Confirm",
        "cancel": "Cancel",
        "deleting": "Deleting...",
        "cannotDeleteProcessing": "Cannot delete while processing"
      },
      "pagination": "Showing {{shown}} of {{total}} documents",
      "status": {
        "processing": "Processing",
        "ready": "Ready",
        "error": "Error",
        "partial_error": "Partial Error",
        "quarantined": "Quarantined",
        "pending_approval": "Pending Approval",
        "superseded": "Superseded",
        "unknown": "Unknown",
        "partialErrorAction": "Processing incomplete — may not appear in protocol search. Use Retry to reprocess."
      },
      "category": {
        "guideline": "Guideline",
        "protocol": "Protocol",
        "procedure": "Procedure",
        "policy": "Policy",
        "standard": "Standard",
        "article": "Article",
        "reference": "Reference",
        "unknown": "Unknown"
      },
      "date": {
        "today": "Today",
        "yesterday": "Yesterday",
        "daysAgo": "{{count}} days ago"
      },
      "loadMore": "Load More",
      "visibility": {
        "private": "Private",
        "organisation": "Organisation",
        "changeError": "Could not change visibility. Please try again.",
        "pendingApproval": "{{name}} — pending approval",
        "sentForApproval": "Sent for approval to {{names}}",
        "sharedWithYou": "Shared with you"
      },
      "search": "Search documents...",
      "retry": {
        "title": "Retry processing",
        "success": "Retry started.",
        "error": "Could not retry processing. Please try again.",
        "invalidState": "This document is no longer in a state that can be retried."
      },
      "bulk": {
        "selected": "{{count}} selected",
        "selectAll": "Select all",
        "selectRow": "Select {{title}}",
        "makeOrganisation": "Make organisation-wide",
        "makePrivate": "Make private",
        "retry": "Retry",
        "delete": "Delete",
        "clear": "Clear selection",
        "working": "Working…",
        "confirmDelete": "Delete {{count}} document(s)? This cannot be undone.",
        "visibilityDone": "{{count}} document(s) updated.",
        "visibilityPartial": "{{done}} updated, {{failed}} failed.",
        "deleteDone": "{{count}} document(s) deleted.",
        "deletePartial": "{{done}} deleted, {{failed}} failed.",
        "retryDone": "Retry started for {{count}} document(s).",
        "retryPartial": "Retry started for {{done}}, {{failed}} failed.",
        "noRetryable": "None of the selected documents can be retried.",
        "sentForApproval": "{{count}} sent for approval.",
        "error": "Could not complete the bulk action. Please try again."
      },
      "byOwner": "by {{name}}",
      "searching": "Searching…",
      "searchEmpty": "No matches. Documents still processing are not searchable yet.",
      "extractsHeading": "Key statements",
      "extractPage": "p. {{page}}",
      "extractFromFigure": "from a figure",
      "unreadableSource": "{{title}}: page(s) {{pages}} could not be read — check the source directly.",
      "extractKind": {
        "dose": "Dose",
        "unknown": "Unknown"
      },
      "share": "Share document"
    },
    "approvals": {
      "approve": "Approve",
      "reject": "Reject",
      "quorumPending": "Approval recorded — {{approvals}} of {{quorum}} required",
      "alreadyDecided": "This request was already decided.",
      "decideError": "Could not record the decision. Please try again.",
      "loadError": "Could not load pending approvals.",
      "approved": "Approved — the change is now live.",
      "rejected": "Request rejected.",
      "hasMore": "More pending than shown — decide these to load the rest.",
      "accessGranted": "Access granted.",
      "accessDenied": "Request denied.",
      "deny": "Deny",
      "label": {
        "grantToUser": "{{name}} wants {{level}} access",
        "grantToGroup": "Share {{title}} with {{grantee}}",
        "publish": "Publish {{title}} to the organisation"
      },
      "signoffsRecorded": "{{count}} approval(s) recorded so far"
    },
    "sharing": {
      "addTargets": "Share with",
      "target": {
        "people": "People",
        "roles": "Roles",
        "units": "Units"
      },
      "kind": {
        "person": "Person",
        "role": "Role",
        "unit": "Unit"
      },
      "role": {
        "viewer": "Viewer",
        "editor": "Editor",
        "owner": "Owner",
        "demographics": "Demographics"
      },
      "withAccess": "Who has access",
      "sentForApproval": "Sent for approval — will be reviewed by {{names}}",
      "sentForApprovalWillAppear": "Sent for approval — the share will appear in the list once reviewed by {{names}}",
      "selectRole": "Select a role",
      "selectUnit": "Select a unit",
      "rolesLoadError": "Could not load roles",
      "unitsLoadError": "Could not load units",
      "noRoles": "No roles available",
      "noUnits": "No units available",
      "error": {
        "roleRequired": "Select a role",
        "unitRequired": "Select a unit"
      },
      "visibility": "Visibility",
      "pendingError": "Could not load pending approvals."
    },
    "tabs": {
      "documents": "Documents",
      "approvals": "Approvals"
    },
    "detail": {
      "backToList": "Back to documents",
      "title": "Document",
      "openSource": "Open source",
      "download": "Download",
      "notReady": "Bytes available once processing finishes.",
      "metadata": "Metadata",
      "filename": "Filename",
      "mimeType": "MIME",
      "sourceType": "Source type",
      "sourceId": "Source",
      "chunkCount": "Chunks",
      "createdAt": "Created",
      "updatedAt": "Updated",
      "scopeTarget": "Scope target",
      "owner": "Owner",
      "versions": "Versions",
      "versionsEmpty": "No version history recorded for this document.",
      "versionsUnavailable": "Version history could not be loaded.",
      "versionNo": "v{{no}}"
    }
  },
  "errors": {
    "notFound": "Page not found",
    "accessDenied": "You don't have access to this resource, or it no longer exists. Try signing in as a different user or contact the resource owner.",
    "resourceNotFound": "This resource is no longer available.",
    "connection": "Couldn't reach the server. Please check your connection and try again.",
    "serverFault": "Something went wrong on our side. Please try again.",
    "configLoadFailed": "Configuration could not be loaded.",
    "backendUnreachable": "Error: Backend not reachable",
    "unexpectedError": "An unexpected error occurred. Please try reloading the page.",
    "reloadPage": "Reload page",
    "goHome": "Go to start page"
  },
  "health": {
    "checking": "Checking connection...",
    "connecting": "Connecting to server...",
    "starting": "Server starting...",
    "initializing": "Initializing app...",
    "ready": "Ready",
    "connected": "Connected",
    "disconnected": "Server unavailable",
    "retrying": "Retrying connection...",
    "offline": "Offline",
    "online": "Online",
    "unknown": "Unknown"
  },
  "sse": {
    "liveUpdatesDisabled": "Live updates unavailable. Tap to reload.",
    "schemaOutOfDate": "Live updates are unavailable because this app version is out of date. Please reload."
  },
  "confidence": {
    "high": "Verified sources",
    "medium": "Source info",
    "low": "Verify information",
    "showReasoning": "Show source details",
    "sourceCount": "{{count}} source",
    "sourceCount_other": "{{count}} sources",
    "topScore": "Top match",
    "justify": "Why this confidence level?",
    "justifyPrompt": "Please justify your confidence level for this answer."
  },
  "carePlan": {
    "title": "Care plan",
    "homeTitle": "Care plans",
    "patientLabelAria": "Patient",
    "version": "Version {{version}}",
    "copyLink": "Copy link",
    "linkCopied": "Copied",
    "daySelector": "Day",
    "addIntervention": "Add intervention",
    "interventionDetails": "Intervention details",
    "nothingPlanned": "Nothing planned",
    "unassigned": "Unassigned",
    "durationMinutes": "{{minutes}} min",
    "fieldDay": "Day",
    "fieldTime": "Time",
    "fieldDuration": "Minutes",
    "fieldTitle": "What is planned",
    "fieldTitlePlaceholder": "Brief title…",
    "fieldAssignee": "Performed by",
    "saving": "Saving…",
    "retime": "Move",
    "remove": "Remove",
    "noDisciplines": "This organisation has no clinical roles yet.",
    "noDisciplinesHint": "A care plan is planned per discipline, and a discipline is a role of the organisation. Ask an administrator to create them.",
    "conflictRemoved": "Somebody else removed this intervention. The board now shows the current plan.",
    "commandFailed": "The change was not saved. Please try again.",
    "addIncomplete": "Give the intervention a title, a time and a length.",
    "retimeIncomplete": "Give the intervention a time and a length.",
    "readFailed": "This care plan could not be read.",
    "chatPlaceholder": "Instruct the agent…",
    "caseloadFailed": "The caseload could not be read.",
    "emptyCaseload": "No patients are admitted.",
    "emptyCaseloadHint": "A care plan belongs to a stay. Admit a patient to plan her week.",
    "conversationUnresolved": "This conversation could not be opened.",
    "conversationHasNoStay": "This conversation is not about an admitted patient, so there is no care plan to open.",
    "faceNeedsPatient": "A care plan belongs to a patient. Open one from the ward.",
    "stayUnresolved": "This patient's stay could not be read.",
    "patientNotAdmitted": "This patient is not admitted, so there is no stay to plan.",
    "executionInProgress": "In progress",
    "executionCompleted": "Done",
    "executionCancelled": "Cancelled",
    "executionMissed": "Missed",
    "executionUnavailable": "What has already been done could not be read, so this week shows the plan only."
  },
  "roster": {
    "homeTitle": "Shift Planner",
    "newRoster": "New roster",
    "untitled": "Untitled roster",
    "emptyHomeTitle": "No rosters yet",
    "emptyTitle": "No shifts yet",
    "nurseColumn": "Nurse",
    "daySelector": "Day",
    "offDuty": "Off",
    "share": "Share",
    "shareFallbackTitle": "Shift roster",
    "sharedByViewOnly": "Shared by {{author}} · view only",
    "viewOnly": "View only",
    "emptyViewerHint": "The planner has not added shifts yet.",
    "myRosters": "My rosters",
    "sharedWithMe": "Shared with me",
    "sharedChip": "Shared",
    "byAuthor": "by {{author}}",
    "editFailed": "Could not save the change. Please try again.",
    "optimizing": "Troi is optimizing…",
    "load_one": "{{count}} shift",
    "load_other": "{{count}} shifts",
    "group": {
      "other": "Other"
    },
    "team": {
      "none": "No team members on this ward yet.",
      "loadError": "Could not load the ward team."
    },
    "horizon": {
      "week": "Week",
      "twoWeeks": "2 weeks",
      "month": "Month",
      "prev": "Previous period",
      "next": "Next period",
      "days": "{{count}} days"
    },
    "status": {
      "updating": "updating…",
      "occurrencesUnavailable": "Shift names and what has been worked could not be read, so cells show their code only"
    },
    "cell": {
      "change": "Change shift for {{nurse}}"
    },
    "picker": {
      "clear": "Clear (off duty)"
    },
    "empty": {
      "scope": "{{count}} days · {{range}}",
      "create": "Create roster"
    },
    "troi": {
      "title": "Ask Troi",
      "open": "Ask Troi",
      "hint": "Describe a change in plain words — e.g. \"give Anna the weekend off\". Troi applies it to the board.",
      "placeholder": "Ask Troi to adjust the roster…"
    }
  },
  "triples": {
    "relatedResources": "Related resources",
    "openProtocol": "Open protocol",
    "startProtocol": "Start protocol",
    "notYetWired": "Not yet wired",
    "notYetWiredToast": "This resource is not yet wired up.",
    "unavailable": "Related resources unavailable",
    "unavailableHint": "Could not load related resources for this answer. Please try again in a moment.",
    "runner": {
      "description": "Step through the protocol",
      "loadFailed": "Could not load protocol.",
      "stepFailed": "Could not advance protocol step.",
      "retry": "Retry",
      "done": "Done",
      "backToStart": "Back to start",
      "errorCodes": {
        "protocolRunFailed": "Protocol run failed",
        "protocolRunInternal": "Internal protocol runtime error"
      }
    }
  },
  "compatibility": {
    "homeTitle": "Y-site compatibility",
    "subtitle": "Y-site verdict",
    "loading": "Loading matrix …",
    "parseError": "The compatibility result could not be read.",
    "newCheck": "New check",
    "untitled": "Untitled check",
    "emptyHomeTitle": "No checks yet",
    "emptyHomeDescription": "Open the Y-site matrix to check whether two drugs can be co-infused",
    "datasetLabel": "Dataset",
    "pairsCount": "{{count}} pairs",
    "validUntil": "valid until",
    "search": {
      "placeholder": "Search a drug — name, ATC, SNOMED …",
      "clear": "Clear search",
      "noResults": "No drug matches “{{query}}”.",
      "offMatrix": "Looking up “{{query}}” in Swiss medication data."
    },
    "legend": {
      "title": "Legend",
      "ok": "Compatible",
      "warn": "Flush",
      "bad": "Incompatible",
      "muted": "No data"
    },
    "toneFilter": {
      "groupLabel": "Show verdict tones",
      "toggleOn": "Hide {{tone}} cells",
      "toggleOff": "Show {{tone}} cells",
      "showAll": "Show all",
      "allHidden": "All tones hidden — tap a legend chip to bring cells back."
    },
    "tabs": {
      "aria": "Compatibility views",
      "matrix": "Matrix",
      "carriers": "Carriers",
      "separate": "Separate administration"
    },
    "matrix": {
      "title": "Compatibility matrix",
      "self": "Same drug",
      "noData": "No data",
      "ariaCell": "{{a}} with {{b}}: {{verdict}}"
    },
    "carriers": {
      "title": "Carrier compatibility",
      "empty": "No carrier compatibility data in this matrix.",
      "noEntry": "No entry"
    },
    "separate": {
      "title": "Drugs for separate administration",
      "emptyTitle": "No drugs in this matrix require separate administration.",
      "selectAria": "{{drug}} — {{verdict}}"
    },
    "verdicts": {
      "compatible_same_lumen": "Compatible — co-administer through one lumen",
      "compatible_with_all_carriers": "Compatible with all standard carrier solutions",
      "requires_line_flush": "Flush line between drugs",
      "incompatible": "Incompatible — do not co-administer",
      "no_data": "No data"
    },
    "derivedNote": "Derived verdict — not directly verified in the source matrix.",
    "selfPairNote": "Same drug on both axes — Y-site self-mix is not meaningful.",
    "panel": {
      "verdictTitle": "Y-site verdict",
      "atc": "ATC",
      "emptyTitle": "Select a drug",
      "emptyHint": "Tap a cell for a Y-site verdict, or a drug name for the overview.",
      "close": "Hide details panel",
      "expand": "Show details panel",
      "overlayTitle": "Drug details",
      "resizeHandle": "Resize details panel",
      "drugInfoTitle": "Drug information"
    },
    "medication": {
      "loading": "Loading drug data…",
      "error": "Couldn’t load medication data. Edit the search to retry.",
      "notFound": "Not found in any medication database.",
      "ingredients": "Active ingredients",
      "fachinfo": "Fachinformation",
      "showMore": "Show full information ({{count}})",
      "showLess": "Show less",
      "sourceLabel": "Source: {{source}}",
      "tier": {
        "internal": "Hospital formulary",
        "national": "Swiss Medic (SAI)",
        "international": "NHS dm+d (UK)"
      }
    },
    "pairPicker": {
      "slotA": "Drug A",
      "slotB": "Drug B",
      "pick": "Pick {{slot}}",
      "pickShort": "Choose a drug",
      "change": "Change {{slot}}",
      "clear": "Clear {{slot}}",
      "prompt": "Pick two drugs to see their Y-site verdict.",
      "noResults": "No drug matches your search."
    },
    "notice": {
      "noData": "No data — needs human review",
      "institution_not_registered": "Institution not registered for compatibility lookups.",
      "drug_not_recognized": "Drug was not recognised.",
      "pair_not_in_matrix": "This pair is not in this institution's matrix."
    }
  },
  "patients": {
    "title": "Patients",
    "attributes": {
      "pattern_hint": "Format: {{pattern}}",
      "ward": "Ward",
      "bed": "Bed",
      "room": "Room",
      "unit": "Unit",
      "admission_ref": "Admission ref.",
      "age": "Age",
      "glasgow": "Glasgow Coma Scale",
      "mobility": "Mobility",
      "main_diagnosis": "Main diagnosis",
      "resuscitation_status": "Resuscitation status",
      "coding_status": "Coding status"
    },
    "register": {
      "title": "Register patient",
      "labelPreview": "Preview",
      "wardLoadError": "Could not load the unit list — a unit is required to register a patient.",
      "wardPlaceholder": "Select a unit",
      "submit": "Register",
      "submitting": "Registering...",
      "configUnavailable": "Loading configuration...",
      "error": "Could not register patient.",
      "admissionLink": {
        "title": "Admission link",
        "explanation": "The real admission identifier for this unit. Used to link this patient to their KIS record — never shown again after registration except through an audited reveal.",
        "tokenLabel": "Admission reference",
        "tokenExplanation": "This reference is now the patient's visible admission pointer. Note it if needed — it will not be shown here again.",
        "continue": "Continue"
      },
      "needAnyAttribute": "Enter at least one detail so the patient can be identified.",
      "justRegistered": "{{patient}} registered",
      "batchCount_one": "{{count}} registered",
      "batchCount_other": "{{count}} registered",
      "moreFields": "More details",
      "done": "Done",
      "submitNext": "Register next",
      "save": "Save",
      "staleWrite": "Someone else changed this patient while you were editing. The form now shows what is stored — apply your change again and save.",
      "revisionUnavailable": "The current version of this record could not be read, so it cannot be saved yet.",
      "schemaUnavailable": "The fields for this patient’s unit could not be loaded.",
      "pickUnitFirst": "Select a unit to see the fields it records."
    },
    "admissionLink": {
      "fields": {
        "case_number": "Case number (KIS)"
      }
    },
    "list": {
      "stale": "Updating...",
      "empty": {
        "title": "No patients yet",
        "description": "Register a patient to get started."
      },
      "loadError": {
        "title": "Could not load the list.",
        "retry": "Try again"
      }
    },
    "assign": {
      "title": "Assign to patient",
      "action": "Assign to patient",
      "current": "Current assignment",
      "choose": "Choose a patient",
      "unassign": "Remove assignment",
      "unknownPatient": "Unknown patient",
      "error": "Could not assign session."
    },
    "unassign": {
      "error": "Could not remove assignment."
    }
  },
  "patientAdmin": {
    "homeTitle": "Patient Administration",
    "subtitle": "Ward census",
    "list": {
      "title": "Patients",
      "addNew": "Register new patient",
      "loadError": {
        "title": "Could not load patients.",
        "retry": "Try again"
      },
      "empty": {
        "title": "No patients yet",
        "description": "Register a patient to get started."
      },
      "showDischarged": "Show discharged"
    },
    "detail": {
      "selectPrompt": "Select a patient to see their stay.",
      "currentPlacement": "Current placement",
      "unit": "Unit",
      "noActiveStay": "Not currently admitted",
      "stayHistory": "Stay history",
      "stale": "Updating...",
      "noHistory": "No stays recorded yet.",
      "noHistoryDescription": "Admissions and transfers will appear here.",
      "loadError": {
        "title": "Could not load the stay history.",
        "retry": "Try again"
      },
      "class": "Class",
      "status": "Status",
      "admittedAt": "Admitted",
      "dischargedAt": "Discharged",
      "disposition": "Disposition",
      "dispositionsUnavailable": "Discharge dispositions are not available right now. Please try again shortly.",
      "responsibleService": "Service",
      "timeline": "Placement events",
      "attributesTitle": "Attributes",
      "awaitingCaseNumber": "No case number",
      "noAttributes": "No attributes recorded.",
      "codenameExplanation": "Automatically generated pseudonym derived from the patient reference — no name is stored.",
      "admittedToday": "admitted today ({{at}})",
      "admittedSince_one": "admitted 1 day ago ({{at}})",
      "admittedSince_other": "admitted {{count}} days ago ({{at}})",
      "notInList": "This patient is not in the current list",
      "notInListDescription": "They may have been discharged — turn on “Show discharged”."
    },
    "overview": {
      "totalPatients": "Registered patients",
      "otherWards": "+{{count}} more",
      "unavailable": "Census unavailable right now"
    },
    "actions": {
      "admit": "Admit",
      "transfer": "Transfer",
      "discharge": "Discharge",
      "cancel": "Cancel",
      "continue": "Continue",
      "confirmAdmit": "Admit to unit",
      "confirmTransfer": "Transfer to unit",
      "confirmTransferPrompt": "Transfer {{patient}} to {{unit}}?",
      "confirmDischarge": "Discharge patient",
      "confirmDischargePrompt": "Discharge {{patient}} — {{disposition}}?",
      "chooseUnit": "Choose a unit",
      "chooseDisposition": "Choose a disposition",
      "submitting": "Saving…",
      "editAttributes": "Edit attributes"
    },
    "admissionRef": {
      "title": "Admission link",
      "loadError": "Could not load linkage status.",
      "unlinkedHint": "This admission reference is not linked to a KIS case yet.",
      "linkedHint": "Linked to a KIS case.",
      "linkNow": "Link now",
      "reveal": "Reveal admission link",
      "linkTitle": "Link admission reference",
      "linkExplanation": "Enter the real admission identifier for this unit. This links the patient's admission reference to their KIS record.",
      "linkSubmit": "Save link",
      "linkError": "Could not save the admission link. Please try again.",
      "revealTitle": "Reveal admission link",
      "revealDescription": "Revealing this link is recorded in the audit trail.",
      "reasonLabel": "Reason for access",
      "reasonPlaceholder": "Select a reason",
      "reasonsUnavailable": "Disclosure reasons are unavailable right now. Please try again shortly.",
      "reasons": {
        "care_handover": "Care handover",
        "billing_query": "Billing query",
        "kis_reconciliation": "KIS reconciliation",
        "other": "Other"
      },
      "invalidReasonCode": "Choose a valid reason.",
      "justificationLabel": "Justification",
      "justificationPlaceholder": "Why you need this now",
      "notFound": "This admission link is not available.",
      "revealFailed": "Could not reveal the admission link. Please try again.",
      "confirm": "Reveal",
      "revealing": "Revealing…",
      "resultTitle": "Admission link",
      "resultWarning": "This information is shown once and is not stored in this session.",
      "done": "Done"
    },
    "class": {
      "inpatient": "Inpatient",
      "emergency": "Emergency",
      "observation": "Observation",
      "outpatient": "Outpatient"
    },
    "status": {
      "in_progress": "In progress",
      "discharged": "Discharged",
      "cancelled": "Cancelled",
      "not_admitted": "Not admitted"
    },
    "disposition": {
      "home": "Home",
      "transfer": "Transferred",
      "deceased": "Deceased",
      "against_advice": "Against medical advice"
    },
    "eventType": {
      "admit": "Admitted",
      "transfer": "Transferred",
      "discharge": "Discharged",
      "cancel_admit": "Admission cancelled",
      "cancel_transfer": "Transfer cancelled",
      "cancel_discharge": "Discharge cancelled"
    },
    "errors": {
      "noActiveEncounter": "This patient has no active stay. Admit them first.",
      "encounterInProgress": "This patient already has an active stay.",
      "patientMoved": "The patient has moved since this action was requested. Check their current unit and try again.",
      "patientReAdmitted": "The patient's location changed. Check their current unit and try again.",
      "admitSuperseded": "The patient was discharged at the same time. Check their current status.",
      "placementRequired": "Choose a unit for this patient.",
      "locationHasChildren": "This unit has sub-units. Choose a specific ward or bed.",
      "invalidClass": "Choose a valid class.",
      "invalidDisposition": "Choose a valid disposition.",
      "admitFailed": "Could not admit the patient. Please try again.",
      "transferFailed": "Could not transfer the patient. Please try again.",
      "dischargeFailed": "Could not discharge the patient. Please try again.",
      "updateAttributesFailed": "Could not save the attributes. Please try again."
    },
    "loading": "Loading…"
  },
  "shifts": {
    "title": "Shifts",
    "patient": {
      "label": "Patient",
      "placeholder": "Choose a patient"
    },
    "nurse": {
      "placeholder": "Type a name",
      "unknown": "Unknown",
      "free": "free",
      "patientLoad_one": "{{count}} patient",
      "patientLoad_other": "{{count}} patients"
    },
    "handover": {
      "action": "Hand over",
      "title": "Hand over patient",
      "curation": "What travels with the patient",
      "curationHint": "Flag the conversations your colleague should see first.",
      "noteLabel": "Handover note",
      "notePlaceholder": "Anything your colleague should know…",
      "start": "Start handover",
      "starting": "Starting handover…",
      "startHint": "Your colleague joins the Rapport. Responsibility stays with you until the patient is reassigned.",
      "startError": "Could not start the handover.",
      "flaggedIntro": "Flagged for the handover:",
      "defaultSeed": "I am handing over this patient. Please draft a short Rapport.",
      "sessionTitle": "Handover {{patient}}",
      "picker": {
        "onShift": "On shift",
        "loadError": "Could not load who is on shift.",
        "empty": "No colleagues on shift on your ward.",
        "searchOther": "Search another nurse"
      }
    },
    "journey": {
      "title": "Your path through the shift",
      "youAreHere": "You are here",
      "start": "Start your shift",
      "takeover": "Take over patients",
      "patientCount_one": "{{count}} patient in your care",
      "patientCount_other": "{{count}} patients in your care",
      "handover": "Hand over",
      "rapportRunning_one": "Rapport running for {{count}} patient",
      "rapportRunning_other": "Rapport running for {{count}} patients",
      "handoverHint": "Towards the end of your shift, per patient.",
      "end": "End your shift"
    },
    "loadError": "Could not load your shift.",
    "offDuty": {
      "title": "You're not on shift",
      "description": "Start your shift to take care of your patients."
    },
    "onDuty": {
      "title": "On shift",
      "patientCount_one": "{{count}} patient",
      "patientCount_other": "{{count}} patients"
    },
    "myPatients": "My patients",
    "noPatients": {
      "title": "No patients yet",
      "description": "Add a patient to start caring for them."
    },
    "endAssignment": {
      "action": "End",
      "error": "Could not end the assignment."
    },
    "addPatient": {
      "title": "Add a patient",
      "submitting": "Adding…",
      "submit": "Add patient",
      "none": {
        "title": "No more patients to add",
        "description": "Every registered patient is already in your shift."
      }
    },
    "end": {
      "submitting": "Ending…",
      "submit": "End shift",
      "error": "Could not end the shift."
    },
    "assign": {
      "error": "Could not assign the patient."
    }
  },
  "sharing": {
    "roleLabel": "Access level",
    "searchTruncated": "Showing {{shown}} of {{total}} — refine your search",
    "searchFailed": "Search failed. Please try again.",
    "error": {
      "lastOwner": "Cannot remove the last owner. Transfer ownership first."
    }
  },
  "approvals": {
    "title": "Approvals",
    "backHome": "Back to home",
    "empty": "No pending approvals.",
    "sections": {
      "documents": "Documents",
      "units": "Units"
    }
  },
  "colleague": {
    "detailsAriaLabel": "Details for {{name}}",
    "title": "Colleagues with experience",
    "yearsAbbrev": "{{years}}y"
  },
  "offline": {
    "cacheCount": "{{count}} cached answer",
    "cacheCount_other": "{{count}} cached answers",
    "cacheDescription": "Your last 10 questions and answers, available even without an internet connection.",
    "cacheTitle": "Cached answers",
    "citationCount": "{{count}} source",
    "citationCount_other": "{{count}} sources",
    "clearCache": "Clear cache",
    "emptyCache": "No answers cached yet",
    "viewCached": "Cached answers"
  },
  "time": {
    "daysAgo": "{{count}} day",
    "daysAgo_other": "{{count}} days",
    "hoursAgo": "{{count}} h",
    "hoursAgo_other": "{{count}} h",
    "justNow": "just now",
    "minutesAgo": "{{count}} min",
    "minutesAgo_other": "{{count}} min"
  },
  "footer": {
    "disclaimer": "Documentation and guideline search for nursing professionals."
  },
  "feedback": {
    "failedDescription": "Your feedback could not be saved. Please try again.",
    "helpful": "Helpful answer",
    "unhelpful": "Unhelpful answer",
    "viewBookmark": "View bookmark",
    "saveBookmark": "Save as bookmark"
  },
  "elicitation": {
    "error": {
      "fieldRequired": "This field is required.",
      "required": "Please fill in all required fields.",
      "submit": "Failed to submit. Please try again.",
      "network": "Network error. Please try again."
    },
    "pleaseSelect": "Please select…",
    "decline": "Decline"
  },
  "uiAction": {
    "error": {
      "generic": "Action failed. Please try again.",
      "notSent": "Action could not be sent"
    },
    "externalLink": {
      "title": "Open external link?",
      "body": "This will open {{origin}} in a new tab."
    }
  },
  "skills": {
    "header": {
      "title": "My knowledge profile"
    },
    "loading": {
      "ariaLabel": "Loading"
    },
    "error": {
      "loadFailed": "Your skills could not be loaded.",
      "unknownError": "Unknown error.",
      "retry": "Try again"
    },
    "section": {
      "declare": "Declare a skill",
      "view": "View"
    },
    "view": {
      "list": "List",
      "map": "Knowledge map",
      "switcherAriaLabel": "Choose a view"
    },
    "form": {
      "labelPlaceholder": "What have you worked with? For example sepsis management",
      "labelAriaLabel": "Skill in your own words",
      "addButton": "Add",
      "catalogueAriaLabel": "Skill from the catalogue",
      "catalogueNone": "No catalogue skill",
      "catalogueLoading": "Loading the catalogue…",
      "catalogueFailed": "The skill catalogue could not be loaded. You can still declare a skill in your own words.",
      "catalogueNotConfigured": "No skill catalogue is declared for this deployment. Name your skill in your own words."
    },
    "proposed": {
      "title": "Proposed by the curator",
      "empty": "No proposals. The curator reads your sessions — new proposals appear here."
    },
    "proposal": {
      "accept": "Accept",
      "reject": "Reject",
      "acceptAriaLabel": "Accept: {{label}}",
      "rejectAriaLabel": "Reject: {{label}}",
      "reasoningLoading": "Loading the reasoning…",
      "reasoningFailed": "The reasoning could not be loaded. Load it before you decide.",
      "reasoningMissing": "This proposal carries no reasoning."
    },
    "pending": {
      "title": "What you are working toward",
      "empty": "Nothing you are currently working toward.",
      "target": "Target by {{due}} · {{basis}}",
      "qualificationStarts": "Certificate valid from {{date}}",
      "recordsLoading": "Loading the records…",
      "recordsFailed": "The records behind this could not be loaded."
    },
    "targetBasis": {
      "declared": "on your own declaration",
      "qualified": "on the institution's verification"
    },
    "held": {
      "title": "My skills",
      "empty": "Nothing recorded yet. Declare what you have worked with above.",
      "publish": "Publish",
      "unpublish": "Withdraw",
      "publishAriaLabel": "Publish: {{label}}",
      "unpublishAriaLabel": "Withdraw: {{label}}",
      "showEndorsements": "Endorsements from colleagues"
    },
    "rejected": {
      "title": "Rejected"
    },
    "basis": {
      "declaration": "Self-declared",
      "endorsement": "From colleagues",
      "qualification": "Verified by the institution",
      "attempt": "From training modules",
      "proposal": "Proposed",
      "target": "Target"
    },
    "badges": {
      "validUntil": "Valid until {{date}}"
    },
    "endorsements": {
      "empty": "No endorsements from colleagues yet.",
      "loadFailed": "The endorsements could not be loaded.",
      "colleague": "A colleague",
      "noComment": "Endorsed, without a comment."
    },
    "map": {
      "clinicalConcepts": "Clinical concepts",
      "furtherSkills": "Further skills",
      "empty": "Nothing here yet."
    },
    "toast": {
      "saveFailed": "Could not be saved",
      "saveFailedDesc": "Please try again.",
      "staleVersion": "Changed in the meantime",
      "staleVersionDesc": "This skill changed since you opened it. The current state is shown."
    }
  },
  "targets": {
    "due": "By {{date}}",
    "overdue": "Was due {{date}}",
    "examDate": "Exam {{date}}",
    "state": {
      "achieved": "Reached",
      "dropped": "Dropped"
    }
  },
  "agent": {
    "chat": {
      "name": "Chat"
    },
    "care-planner": {
      "name": "Care Plan"
    },
    "compatibility": {
      "name": "Compatibility"
    },
    "protocols": {
      "name": "Process Analysis"
    },
    "knowledge-profile": {
      "name": "Knowledge Profile"
    },
    "roster": {
      "name": "Roster"
    },
    "patient-admin": {
      "name": "Patient Administration"
    },
    "learn": {
      "name": "Learn"
    },
    "mentor": {
      "name": "Training Mentor"
    },
    "access": {
      "name": "My access"
    },
    "team-access": {
      "name": "Team access"
    },
    "allocation": {
      "name": "Patient allocation"
    },
    "handover": {
      "name": "Handover"
    }
  },
  "conversation": {
    "state": {
      "active": "Active",
      "done": "Done",
      "needsReview": "To review"
    }
  },
  "admin": {
    "analytics": {
      "dash": {
        "overview": "Overview",
        "latency": "Latency",
        "usage": "Usage",
        "competencies": "Team Competencies",
        "training": "Training",
        "loadError": "Failed to load dashboard — please retry.",
        "slowLoad": "Taking longer than usual — the analytics backend may be starting up."
      }
    },
    "dashboard": {
      "title": "Admin Dashboard",
      "previewTooltip": "Your read-only admin preview ends in {{count}} day.",
      "previewTooltip_other": "Your read-only admin preview ends in {{count}} days.",
      "previewBadge": "Admin preview · {{count}} day left",
      "previewBadge_other": "Admin preview · {{count}} days left",
      "tabs": {
        "queries": "Queries",
        "clusters": "Clusters",
        "sessions": "Sessions",
        "feedback": "Feedback",
        "reported-errors": "Reported errors",
        "approvals": "Approvals",
        "organisation": "Organisation",
        "permissions": "Permissions"
      },
      "tabHelp": {
        "queries": "Browse all query logs. Click a query to see the full session with system prompt and tool calls.",
        "clusters": "Group queries by time, role, experience, or institution to spot patterns.",
        "sessions": "View full chat sessions with messages, citations, confidence, and system prompt.",
        "feedback": "All user feedback (thumbs up/down). Click to see the full session context.",
        "reported-errors": "Client-side errors users tapped \"Report\" on, or that crashed a screen — the destination of the Report action. Newest first.",
        "approvals": "Approve or reject institutional documents pending review. Documents are quarantined until approved.",
        "organisation": "Manage the location hierarchy, roles, who works where, and which patients sit in which unit.",
        "permissions": "Grant or revoke who can reach platform authority, each admin area, and each agent — for a person or a whole role."
      }
    },
    "queryExplorer": {
      "loadError": "Failed to load queries — please retry.",
      "searchPlaceholder": "Search queries...",
      "prev": "Prev",
      "next": "Next",
      "pagePrefix": "p.",
      "citations": "{{count}} citation",
      "citations_other": "{{count}} citations",
      "empty": "No queries found",
      "selectPrompt": "Select a query to view the full session",
      "sessionLoadError": "Failed to load session",
      "feedbackType": {
        "positive": "positive",
        "negative": "negative",
        "incorrect": "incorrect",
        "missing": "missing",
        "other": "other"
      }
    },
    "userSelect": {
      "searchPlaceholder": "Search users...",
      "clearFilter": "Clear user filter",
      "clear": "Clear",
      "loadFailed": "Could not load users.",
      "noResults": "No users found"
    },
    "feedbackExplorer": {
      "timeRange": {
        "day": "Last 24h",
        "week": "Last 7 days",
        "month": "Last 30 days"
      },
      "filter": {
        "all": "All",
        "positive": "Positive",
        "negative": "Negative",
        "incorrect": "Incorrect",
        "missing": "Missing",
        "other": "Other"
      },
      "entriesLabel": "feedback entries",
      "positiveCount": "{{count}} positive",
      "negativeCount": "{{count}} negative",
      "loadError": "Failed to load feedback",
      "empty": "No feedback entries for this time range",
      "noQueryText": "No query text",
      "untitledSession": "Untitled Session",
      "showingEntries": "Showing {{shown}} of {{total}} entries",
      "selectPrompt": "Select a feedback entry to view the full session"
    },
    "queryClusters": {
      "loadError": "Failed to load query clusters",
      "dimension": {
        "time": "Time",
        "role": "Role",
        "experience": "Experience",
        "specialisation": "Specialisation",
        "institution": "Institution"
      },
      "timeRange": {
        "day": "Day",
        "week": "Week",
        "month": "Month"
      },
      "viewCards": "Cards",
      "viewChart": "Chart",
      "empty": "No query clusters found for this dimension",
      "hideExamples": "Hide examples",
      "showExamples": "Show {{count}} example",
      "showExamples_other": "Show {{count}} examples"
    },
    "documentApproval": {
      "serviceUnavailable": "Knowledge service is not available in this environment.",
      "serviceUnavailableHint": "The knowledge-service must be running for document approval.",
      "loadError": "Failed to load pending documents",
      "empty": "No documents pending approval",
      "columnTitle": "Title",
      "columnCategory": "Category",
      "columnStatus": "Status",
      "columnUploaded": "Uploaded",
      "columnChunks": "Chunks",
      "columnActions": "Actions",
      "deleteConfirmPrompt": "Delete permanently?",
      "confirm": "Confirm",
      "approving": "Approving...",
      "approve": "Approve",
      "reject": "Reject",
      "showingDocuments": "Showing {{shown}} of {{total}} documents"
    },
    "sessionMonitor": {
      "loadError": "Failed to load sessions",
      "empty": "No sessions found",
      "selectPrompt": "Select a session to view messages"
    },
    "sessionDetail": {
      "loadErrorTitle": "Could not load this session",
      "loadErrorBody": "Something went wrong loading this session. Please try again shortly.",
      "selectPrompt": "Select a session to view messages",
      "untitled": "Untitled Session",
      "messageCount": "{{count}} message",
      "messageCount_other": "{{count}} messages",
      "noMessages": "No messages in this session",
      "toolTracesUnavailable": "Tool traces unavailable",
      "toolCalls": "{{tool}} ×{{calls}}",
      "imageAttached": "Image attached"
    },
    "reportedErrors": {
      "intro": "Errors users tapped “Report” on, or that crashed a screen — newest first.",
      "refresh": "Refresh",
      "loadError": "Could not load reported errors",
      "empty": "No reported errors yet.",
      "reportedBy": "Reported by {{name}}",
      "reporterUnknown": "Reporter unknown",
      "componentStack": "Component stack",
      "detail": {
        "request": "Request",
        "status": "HTTP status",
        "errorCode": "Error code",
        "origin": "Origin",
        "screen": "Screen",
        "time": "Timestamp",
        "reportId": "Report ID",
        "requestId": "Request ID (server log)",
        "noTrace": "No further technical detail — this report was not about an API call.",
        "session": "Session",
        "turn": "Turn (seq)",
        "agent": "Agent"
      },
      "triage": {
        "owner": "Owner",
        "unassigned": "Unassigned",
        "unassign": "Unassign",
        "status": "Status",
        "assignTo": "Assign to",
        "pick": "Choose …",
        "agents": "Agents",
        "channels": "Channels",
        "history": "History",
        "thread": "Replies",
        "noReplies": "No replies yet.",
        "reply": "Reply",
        "replyPlaceholder": "Write a reply …",
        "loadError": "Could not load triage.",
        "eventFailed": "Could not record the action.",
        "replyFailed": "Could not send the reply.",
        "unassignedEvent": "Unassigned",
        "statuses": {
          "open": "Open",
          "in_progress": "In progress",
          "done": "Done",
          "cancelled": "Cancelled"
        }
      },
      "consoleLog": "Recent browser log",
      "diagnostics": {
        "title": "Under the hood",
        "turnRecords": "Turn records",
        "prompt": "Rendered prompt (pinned version)",
        "promptNote": "Rendered now, for your tools; the withheld-tools part can differ from what the reporter’s turn saw.",
        "unavailable": "Server-side context unavailable: {{reason}}",
        "sessionReadError": "Session read failed: {{reason}}"
      }
    }
  },
  "allocation": {
    "assign": "Assign",
    "assigning": "Assigning…",
    "notOnShift": "Not on shift anymore.",
    "error": "Could not assign — try again.",
    "board": {
      "title": "Shift start",
      "progress": "{{done}} of {{total}} assigned",
      "complete": "All patients assigned — the ward is handed over.",
      "nobodyOnShift": "Nobody is on shift yet — patients can be assigned once a nurse starts her shift.",
      "proposalHint": "Suggested: {{nurse}}",
      "assign": "Assign",
      "change": "Change",
      "load_one": "{{count}} patient",
      "load_other": "{{count}} patients",
      "room": "Room {{room}}",
      "noRoom": "No room",
      "roomsList": "Rooms {{rooms}}",
      "assignRoom": "Assign whole room",
      "assignRoomTo": "Assign whole room to…",
      "split": "split",
      "spread": "Spread across rooms",
      "partialAssign": "{{failed}} of {{total}} beds could not be assigned.",
      "noPatients": "No patients on the ward.",
      "loadError": "Could not load the ward's allocation.",
      "noWard": "No unit assigned to your profile yet.",
      "chatPlaceholder": "Ask for a distribution proposal…",
      "progressLabel": "Patient assignment progress"
    }
  },
  "sessions": {
    "sharing": {
      "expiry": "Expires (optional)",
      "expiryHint": "Time-boxed shares apply to viewer access only."
    }
  },
  "learn": {
    "homeTitle": "Learn",
    "resume": {
      "label": "Continue where you left off",
      "untitled": "Your conversation"
    },
    "targets": {
      "title": "What I'm working toward",
      "loadError": "Could not load your targets.",
      "empty": {
        "title": "No targets yet",
        "description": "Your supervisor can set you a target on a skill — ask the assistant what to work on next."
      }
    },
    "recommended": {
      "title": "Recommended for you",
      "loadError": "Could not load the quiz catalog.",
      "empty": {
        "title": "Nothing to pick up yet",
        "description": "When one of your targets names a published quiz, it shows up here."
      },
      "becauseTarget": "For your target: {{title}}"
    },
    "session": {
      "loading": "Loading…"
    },
    "board": {
      "chatPlaceholder": "Ask about your learning…"
    },
    "actions": {
      "exam": {
        "label": "Exam coming up",
        "submit": "Set goal",
        "dateLabel": "Exam date",
        "request": "I have an exam on {{topic}} on {{date}}. Set me a target on the {{topic}} skill with that exam date, and create private practice material for it."
      },
      "practice": {
        "label": "Make me practice",
        "submit": "Create",
        "request": "Create a private practice quiz on {{topic}}, grounded in our guidelines."
      },
      "topicPlaceholder": "Which topic?",
      "topicLabel": "Topic"
    }
  },
  "mentor": {
    "board": {
      "title": "Mentor",
      "switchUnit": "Switch unit",
      "newTarget": "New target",
      "summary": "{{trainees}} trainees · {{openTargets}} open · {{achievedTargets}} reached",
      "loadError": "Could not load the mentor board.",
      "chatPlaceholder": "Ask the mentor assistant…",
      "noTargets": "No targets set yet.",
      "targetsHeading": "Targets",
      "targetCounts": "{{open}} open · {{achieved}} reached",
      "showDetail": "Show detail",
      "hideDetail": "Hide detail",
      "notFramed": "This conversation isn’t framed to a unit yet.",
      "roster": {
        "title": "Trainees",
        "empty": {
          "title": "No trainees yet",
          "description": "Trainees appear here once they join this unit."
        }
      }
    },
    "targets": {
      "trainee": "Trainee",
      "traineePlaceholder": "Choose a trainee…",
      "skill": "Skill",
      "skillPlaceholder": "Choose a skill…",
      "skillsEmpty": "The skill catalogue is empty, so there is nothing to set a target on yet.",
      "skillsError": "Could not load the skill catalogue.",
      "dueDate": "By when",
      "drop": "Drop",
      "dropping": "Dropping…",
      "save": "Set target",
      "saving": "Saving…"
    },
    "quiz": {
      "sectionTitle": "Quizzes",
      "emptyTitle": "No quizzes yet",
      "empty": "Ask the assistant to generate a quiz from one of your unit’s documents, or model one in the protocol Studio.",
      "listErrorTitle": "Could not load the quizzes",
      "listError": "The quiz catalogue could not be loaded.",
      "statusDraft": "Draft",
      "statusPublished": "Published",
      "statusInReview": "In review",
      "statusArchived": "Archived"
    },
    "curricula": {
      "assignError": "Could not assign the curriculum. Please try again.",
      "unassignError": "Could not unassign the curriculum. Please try again."
    }
  }
}
